module.exports = __webpack_public_path__ + "static/media/27OCHA16.6c894144.jpg";